import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { baseUrl } from "../../utils/APi";
import { Link, useNavigate } from "react-router-dom";
import { removeFromCart, removeAllFromCart } from "../../store/cart/cartSlice";

import { failed, sucess } from "../../component/toast/Toast";
import { applyCoupon, setCheckout } from "../../store/checkout/checkAction";
import { getAddress } from "../../store/auth/authAction";

import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";
import img7 from "../../assets/main/7.jpg";

const SingleActivity = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${img2})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Portfolio</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <a class="section-16px-regular font-weight-500" href="#">
                    Home
                  </a>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">
                    Portfolio
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-portfolio-single">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <article class="post-inner">
                <div class="post-media">
                  <img src={img7} alt="images" />
                  <div class="post-media-content">
                    <div class="post-media-info link-style-2">
                      <h3 class="section-20px-montserrat margin-bottom-5">
                        Project : Business ERP Software
                      </h3>
                      <div class="media-info-project">
                        <h3 class="client section-16px-regular">
                          Client : Johnson Group, USA
                        </h3>
                        <ul class="entry-tags section-16px-regular">
                          <li>
                            <span class="tags-post">Tags :</span>
                          </li>
                          <li>
                            <a href="services.html">Services</a>
                          </li>
                          <li>
                            <a href="portfolio.html">Trading</a>
                          </li>
                        </ul>
                        <a href="#" class="globe company section-16px-regular">
                          www.yourcompany.com
                        </a>
                      </div>
                    </div>
                    <hr />
                    <div class="post-media-author link-style-2">
                      <div class="media-author section-16px-regular">
                        <span class="author">Author:</span>
                        <span>
                          <a href="team.html">Admin</a>
                        </span>
                      </div>
                      <ul class="share entry-socials section-16px-regular">
                        <li>
                          <a href="#">Fb.</a>
                        </li>
                        <li>
                          <a href="#">Be.</a>
                        </li>
                        <li>
                          <a href="#">Tw.</a>
                        </li>
                        <li>
                          <a href="#">In.</a>
                        </li>
                      </ul>
                      <h3 class="date section-16px-regular">07 / 20 / 2021</h3>
                    </div>
                  </div>
                </div>
                <div class="post-content">
                  <h2 class="section-24px-montserrat">
                    Providing Professional or Expert Advice
                  </h2>
                  <p class="margin-top-17 margin-bottom-27">
                    Consulting is defined as the practise of providing a third
                    party with etise on matter in exchange for a fee. The
                    service may involve either advisory or implementation
                    services. For the consultant, taking an independen center
                    with a caption, link and alt text New Journey to the Mars in
                    the Gutenberg editor, you can drag and drop an image from
                    your computer onto the editing screen.
                  </p>
                  <p>
                    Design comes alive – an app becomes an interactive story
                    that can engage users. Designers have a lot of tools to make
                    a story more interesting. You can align your image to the
                    left, right, or center with a caption, link and alt text New
                    Journey to the Mars in the Gutenberg editor.
                  </p>
                  <div class="quotes">
                    <div class="box-8">
                      <blockquote class="margin-bottom-25">
                        <p class="section-14px-regular font-weight-700 text-808">
                          “ Consulting is defined the practise of providing is
                          third party with expertise on a matters in exchange a
                          free advisory or implementation services ”
                        </p>
                      </blockquote>
                    </div>
                    <div class="box-4">
                      <blockquote class="quotes-2 margin-bottom-25">
                        <p class="section-14px-regular font-weight-700 text-808">
                          “ Consulting is defined the practise of providing is
                          third party with expertise on a matters in exchange a
                          free advisory or implementation services ”
                        </p>
                      </blockquote>
                    </div>
                  </div>
                  <div class="post-list-content box-6">
                    <p class="margin-bottom-15">
                      Becomes an interactive story that can engage users.
                      Designers have a lot of tools to make a story more
                      intersting. You can align your image to the
                    </p>
                    <ul class="list-note-content section-16px-regular line-height-29">
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="post-list-content box-6">
                    <p class="margin-bottom-15">
                      Becomes an interactive story that can engage users.
                      Designers have a lot of tools to make a story more
                      intersting. You can align your image to the
                    </p>
                    <ul class="list-note-content section-16px-regular line-height-29">
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                      <li>
                        <span class="text-accent">
                          Marketing consulting Online Business
                        </span>
                        <span>
                          – an app becomes ans interactive story that can engage
                          users. Designers have tools to make
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="post-images box-8">
                    <img src={img4} alt="images" />
                  </div>
                  <div class="post-images box-4">
                    <img src={img5} alt="images" />
                  </div>
                  <p class="margin-bottom-25">
                    Becomes an interactive story that can engage users.
                    Designers have a lot of tools to make a story more
                    intersting. You can align your image to the leftcenter with
                    a caption, link and alt text New Journey to the Marstaking
                    an independen center with a caption, link and alt text New
                    Journey to the Mars. Consulting is defined as the practise
                    of providing a third party with etise on matter in exchange
                    for a fee. The service may involve either advisory or
                    implementation services. For the consultant, taking an
                    independen center with a caption, link and alt text New
                    Journey to the Mars in the Gutenberg editor, you can drag
                    and drop an image from your computer onto the editing
                    screen.
                  </p>
                  <p>
                    Design comes alive – an app becomes an interactive story
                    that can engage users. Designers have a lot of tools to make
                    a story more interesting. You can align your image to the
                    left, right, or center with a caption, link and alt text New
                    Journey to the Mars in the Gutenberg editor.
                  </p>
                </div>
              </article>
            </div>
            <section class="flat-latest style-2">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="section-title">
                      <h2 class="section-45px-montserrat ">
                        Related Portfolio
                      </h2>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img1} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Lights winged seasons fish abundantly.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img2} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Winged moved stars, fruit creature seed night.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img3} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Given void great you’re good appear also fifth.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default SingleActivity;
